import { render, staticRenderFns } from "./confirmWithdrawal.vue?vue&type=template&id=b7408500&scoped=true"
import script from "./confirmWithdrawal.vue?vue&type=script&lang=js"
export * from "./confirmWithdrawal.vue?vue&type=script&lang=js"
import style0 from "./confirmWithdrawal.vue?vue&type=style&index=0&id=b7408500&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7408500",
  null
  
)

export default component.exports